<template>
  <div
    v-if="forcedUpdate"
    class="alert alert-warning update-banner shadow d-flex align-items-center justify-content-between mb-0 noprint"
    role="alert"
  >
    <span class="mr-3">
      Hay una nueva versión de la plataforma. Guarde su trabajo y actualice
      para continuar.
    </span>
    <button
      type="button"
      class="btn btn-sm btn-primary flex-shrink-0"
      @click="reloadNow"
    >
      Actualizar ahora
    </button>
  </div>
</template>

<script setup>
// eslint-plugin-vue 6.x (anterior a <script setup>) no ve que estos bindings
// se usan en el template. Quitar el disable cuando se actualice el tooling.
/* eslint-disable no-unused-vars */
// Solo aparece en el camino FORZADO (deploy con --force-update, p. ej. un fix
// de seguridad o un cambio de contrato de API). El camino silencioso normal
// nunca muestra UI: la app se actualiza sola en la próxima navegación.
import { forcedUpdate } from "@/composables/useVersionCheck";

const reloadNow = () => window.location.reload();
</script>

<style scoped>
.update-banner {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 2000;
  border-radius: 0;
}
</style>
